import React, { useEffect, useState } from 'react'
import MuiDrawer from '@mui/material/Drawer';
import {Button, TextField} from '@mui/material';
import styled from 'styled-components';
import {Close} from '@mui/icons-material'
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const StyledDrawer = styled(MuiDrawer).withConfig({ shouldForwardProp: (prop) => prop !== 'open' })<{open: boolean;}>`
  height: 100%;
  width: ${p => p.open ? 'auto' : `0`};
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1200;

  .MuiDrawer-paper {
    position: relative;
    transition: width 0.5s ease;
  }

  ${p => p.open && `
    &::before {
      content: '';
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(2px);
      z-index: -1;
    }
  `}
`;

interface ChapterNameDrawerProps {
    name: string;
    open: boolean;
    close: (updatedName?: string) => void;
    updateChapterName: (chapterId: string, newName: string) => void;
    selectedChapterId: string;
}

const ChapterNameDrawer: React.FC<ChapterNameDrawerProps> = ({
                                                                 name,
                                                                 open,
                                                                 close,
                                                                 updateChapterName,
                                                                 selectedChapterId
                                                             }) => {
  const [hasFocused, setHasFocused] = useState(false);
  useEffect(() => {
    if (!open) {
      setHasFocused(false);
    }
  }, [open]);
    const validationSchema = Yup.object().shape({
        chapterName:

            Yup.string()
                .trim(' ')
                .min(3, 'Минимальная длина названия курса - 3 символа')
                .max(200, 'Максимальная длина названия курса - 200 символов')
                .matches(/.*[a-zA-Zа-яА-Я]+.*/, 'Название курса должно содержать хотя бы одну букву')
                .required('Необходимо ввести название')
    });
    return(
        <StyledDrawer variant="permanent" anchor="right" open={open}>
            <div className="chapter-drawer-close" onClick={() => close()}><Close/></div>

            <Formik
                initialValues={{ chapterName: name }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    updateChapterName(selectedChapterId, values.chapterName);
                    close();
                }}
            >
                {({ errors, touched, values, setFieldValue }) => (
                    <Form>
                        <div className="chapter-drawer-content">
                            <div className="constructor-content-title">
                                Редактировать название раздела
                            </div>
                            <div className="corse-content-description">
                                Название раздела должно быть коротким и понятным, отображать контекст контента.
                            </div>
                            <Field as={TextField}
                                   variant="outlined"
                                   placeholder="Введите название"
                                   name="chapterName"
                                   error={errors.chapterName && touched.chapterName}
                                   helperText={(errors.chapterName && touched.chapterName) && errors.chapterName}
                                   className="without-label"
                                   onFocus={() => {
                                     if (!hasFocused) {
                                       setFieldValue('chapterName', '');
                                       setHasFocused(true);
                                     }
                                   }}
                            />
                            <div className={values.chapterName.length > 200 ? "description-input-counter error-text" : "description-input-counter"}>{values.chapterName.length}/200</div>
                        </div>
                        <div className="chapter-drawer-footer" style={{
                            position: 'fixed',
                            bottom: 0,
                            right: 0,
                        }}>
                            <Button type="submit" variant="contained">Сохранить</Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </StyledDrawer>
    );
}
export default ChapterNameDrawer;
